import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import Header from "../components/Header";
import Lookup from "../components/Lookup";

const Results = () => {
  const [result, setResult] = useState([]);
  const { term } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const selectedInstance = searchParams.get("instance");

  const url = `${selectedInstance}/api/v1/search?q=${term}&type=video`;

  useEffect(() => {
    fetch(url)
      .then((res) => res.json())
      .then((json) => setResult(json));
    // Set the document title to the video title
    document.title = `Search: ${term}`;
  }, [term]);

  return (
    <>
      <Header />
      <div className="">
        <Lookup selectedInstance={selectedInstance} />
      </div>
      <div class="flex flex-wrap">
        <div className="p-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4 xl:container mx-auto">
          {result.map((trend) => (
            <div class="relative" key={trend.videoId}>
              <Link
                to={{
                  pathname: `/player/${trend["videoId"]}`,
                  search: `?instance=${selectedInstance}`,
                }}
              >
                <img
                  className="w-full  object-cover object-center rounded-lg"
                  src={`https://i.ytimg.com/vi_webp/${trend["videoId"]}/mqdefault.webp`}
                  alt={trend["title"]}
                />
              </Link>
              <h3 class="mt-2 tracking-widest text-indigo-500 text-xs font-medium title-font">
                <Link
                  to={{
                    pathname: `/channel/${trend["authorId"]}`,
                    search: `?instance=${selectedInstance}`,
                  }}
                >
                  {trend["author"]}
                </Link>
              </h3>
              <h2 class="text-lg text-gray-900 font-medium title-font mb-4">
                <Link
                  to={{
                    pathname: `/player/${trend["videoId"]}`,
                    search: `?instance=${selectedInstance}`,
                  }}
                >
                  {trend["title"]}
                </Link>
              </h2>
              <p class="-mt-4 leading-relaxed text-base">
                {(() => {
                  const dateObj = new Date(trend["lengthSeconds"] * 1000);
                  const hours = dateObj.getUTCHours();
                  const minutes = dateObj.getUTCMinutes();
                  const seconds = dateObj.getSeconds();
                  return (
                    hours.toString().padStart(2, "0") +
                    ":" +
                    minutes.toString().padStart(2, "0") +
                    ":" +
                    seconds.toString().padStart(2, "0")
                  );
                })()}
                <span className="ml-2">{trend["publishedText"]}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Results;
